import { Injectable } from '@angular/core';
import { map } from 'rxjs';

import { SearchApi } from '../../api/search.api';
import { Store } from '../../../../shared/store';
import { MostSearchedTermsState } from './most-searched-terms.state';

const mostSearchedTermsState = new MostSearchedTermsState();

@Injectable({ providedIn: 'root' })
export class MostSearchedTermsStore extends Store<MostSearchedTermsState> {
  mostSearchedTerms$ = this.state$.pipe(map((s) => s.mostSearchedTerms));

  constructor(private searchApi: SearchApi) {
    super(mostSearchedTermsState);
  }

  // SET DATA

  setMostSearchedTerms(nextMostSearchedTerms: string[]): void {
    this.setState({ ...this.state, mostSearchedTerms: nextMostSearchedTerms });
  }

  // GET DATA FROM THE API

  async getMostSearchedTerms(): Promise<void> {
    this.searchApi
      .getFilteredMostSearchedTerms$()
      .subscribe((searchedTerms) => {
        this.setMostSearchedTerms(searchedTerms);
      });
  }
}
